import { render, staticRenderFns } from "./ResultsDocF10.vue?vue&type=template&id=19a1597e&scoped=true&"
import script from "./ResultsDocF10.vue?vue&type=script&lang=ts&"
export * from "./ResultsDocF10.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a1597e",
  null
  
)

export default component.exports